// extracted by mini-css-extract-plugin
export default {"mobileCaret":"_1ohOt5OQ75zq1pQ_l2XjLh"};